import React from 'react'
import { Global, css } from '@emotion/react'

const globalStyles = css`
  .ant-tabs-tab {
    padding: 0.5rem 1.5rem;
    color: #8c8ca1;
    font-size: 15px;
    font-weight: 500;

    :hover {
      color: #d092dd;
    }
  }

  .ant-tabs-tab .ant-tabs-tab-btn a {
    color: #8c8ca1;
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    .ant-tabs-tab-btn,
    .ant-tabs-tab-btn a {
      color: #4a4a68;
    }
  }

  .ant-tabs-tab {
    .ant-tabs-tab-btn {
      display: flex;
      align-items: center;
    }
  }

  .ant-tabs-ink-bar {
    background: #4a4a68;
  }

  .ant-tabs-card {
    width: 100%;

    > .ant-tabs-nav,
    > .ant-tabs-nav > .ant-tabs-nav-wrap,
    > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list,
    > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list > .ant-tabs-tab {
      width: inherit;
    }

    > .ant-tabs-nav > .ant-tabs-nav-wrap > .ant-tabs-nav-list {
      align-items: flex-end;
      height: 60px;
    }

    > .ant-tabs-nav
      > .ant-tabs-nav-wrap
      > .ant-tabs-nav-list
      > .ant-tabs-tab
      > .ant-tabs-tab-btn {
      display: flex;
      align-items: center;
      width: inherit;
      height: inherit;
    }

    > .ant-tabs-nav > .ant-tabs-nav-operations {
      display: none;
    }
  }

  .ant-tabs-card.ant-tabs
    > .ant-tabs-nav
    > .ant-tabs-nav-wrap
    > .ant-tabs-nav-list
    > .ant-tabs-tab {
    position: relative;

    flex: 1 1 0;
    height: 40px;
    border-radius: 4px 4px 0 0;
    border: 0;
    margin: 0 !important;

    font-weight: 600;

    overflow: hidden;
    transition: all 50ms cubic-bezier(0.645, 0.045, 0.355, 1);

    > .ant-tabs-tab-btn {
      position: absolute;
      bottom: 0;
      left: 0;

      display: flex;
      align-items: center;
      width: inherit;
      height: inherit;
      border-radius: 4px 4px 0 0;
      border-top: 1px solid transparent;
      border-right: 1px solid transparent;
      border-bottom: 1px solid #e7e5e9;
      border-left: 1px solid transparent;
      padding: 1rem;
      box-sizing: border-box;
      background-color: #f3f2f4;

      font-weight: 600;
      font-size: 15px;
      color: #8c8ca1;
      letter-spacing: 2%;
      line-height: 140%;
      text-transform: uppercase;
      white-space: pre-wrap;

      transition: all 50ms cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    > .ant-tabs-tab-btn > a,
    > .ant-tabs-tab-btn > span {
      position: absolute;
      bottom: 0;
      left: 0;

      display: flex;
      align-items: center;
      padding-left: 16px;
      border: 0;
      width: 100%;
      height: 100%;

      font-weight: inherit;
      font-size: inherit;
      color: inherit;
      letter-spacing: inherit;
      line-height: inherit;
      text-transform: inherit;
      white-space: inherit;
    }
  }

  .ant-tabs-card.ant-tabs
    > .ant-tabs-nav
    > .ant-tabs-nav-wrap
    > .ant-tabs-nav-list
    > .ant-tabs-tab-active {
    height: 56px;
    border-radius: 4px 4px 0 0;

    box-shadow: 0px -1px 2px rgba(219, 217, 223, 0.15),
      -1px 0px 2px rgba(219, 217, 223, 0.15),
      1px 0px 2px rgba(219, 217, 223, 0.15);

    > .ant-tabs-tab-btn {
      color: #d092dd;
      background-color: white;
      border-radius: 4px 4px 0 0;

      border-top: 1px solid #e7e5e9;
      border-left: 1px solid #e7e5e9;
      border-right: 1px solid #e7e5e9;
      border-bottom: 1px solid transparent;
    }

    > .ant-tabs-tab-btn > a,
    > .ant-tabs-tab-btn > span {
      border: 0;
    }
  }

  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border-right: none;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
  }

  html,
  body {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI',
      Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
      'Noto Color Emoji';
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  svg {
    fill: currentColor;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  ::-webkit-scrollbar {
    width: 0.7em;
  }

  ::-webkit-scrollbar-track {
    background: none;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cfccd4;
    border-radius: 4px;
  }

  @media print {
    * {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`

export const GlobalStyles = () => <Global styles={globalStyles} />
